import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/home-o-2.json)
const homeO2IconData = {
	icon: {
		attrs: [{}, {}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M902.486 419.646c24.235 0.003 43.885 19.651 43.885 43.886v406.477c-0.003 75.941-61.574 137.518-137.517 137.518h-561.726c-75.933-0.006-137.495-61.581-137.499-137.518v-406.477c0-24.235 19.651-43.882 43.885-43.886 24.237 0 43.885 19.648 43.885 43.886v406.477c0.003 27.462 22.269 49.742 49.73 49.749h561.726c27.467 0 49.744-22.282 49.747-49.749v-406.477c0-24.235 19.651-43.882 43.885-43.886z',
			'M499.654 22.289c18.093-7.755 38.595-7.755 56.691 0l3.84 1.783 455.546 259.773c21.675 10.84 30.466 37.206 19.627 58.883-10.163 20.32-33.974 29.317-54.77 21.429l-4.115-1.8-448.482-256.241-448.466 256.241c-21.676 10.837-48.044 2.045-58.885-19.629-10.839-21.677-2.049-48.045 19.628-58.883l459.384-261.556z',
		],
		tags: ['home'],
		width: 1056,
	},
	attrs: [{}, {}],
	properties: {
		code: 59751,
		id: 10,
		name: 'home-o-2',
		order: 3440,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 3,
};

// Create IconBuilder from cond-ui-kit data
const HomeIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	homeO2IconData as any,
	'#89c32e', // Default green color for new navigation
);

export default HomeIconBuilder;
